// Include all modules to be picked up by webpack

//----------------- Non-React -----------------//
// Required
export { default as Megamenu } from './modules/Megamenu';
export { default as StickyBanner } from './modules/StickyBanner';
export { default as StickyHeader } from './modules/StickyHeader';
export { default as MarketingBanner } from './modules/MarketingBanner';
export { default as Hubspot } from './modules/Hubspot';
export { default as CookieBanner } from './modules/CookieBanner';
export { default as Countdown } from './modules/Countdown';
export { default as PromotionTrackGtm } from './modules/PromotionTrackGtm';
export { default as BalancePaymentLogin } from './modules/BalancePaymentLogin';
export { default as BalancePaymentConfirmation } from './modules/BalancePaymentConfirmation';
export { default as BalancePaymentDetails } from './modules/BalancePaymentDetails';
export { default as BalancePaymentError } from './modules/BalancePaymentError';
export { default as BalancePaymentSummary } from './modules/BalancePaymentSummary';
export { default as MakeBalancePayment } from './modules/MakeBalancePayment';
export { default as HotelDetails } from './modules/Hotels/HotelDetails';
export { default as PersonalTravelPlanner } from './modules/PersonalTravelPlanner';
export { default as PromoStrip } from './modules/PromoStrip';

// Dynamic
export { default as AgentLogin } from './dynamic/modules/AgentLogin';
export { default as AgentLoginBar } from './dynamic/modules/AgentLoginBar';
export { default as Brochure } from './dynamic/modules/Brochure';
export { default as CheckAvailability } from './dynamic/modules/CheckAvailability';
export { default as CreatePayment } from './dynamic/modules/CreatePayment';
export { default as CtaResize } from './dynamic/modules/CtaResize';
export { default as DropdownAlignment } from './dynamic/modules/DropdownAlignment';
export { default as ErrorLogger } from './dynamic/modules/ErrorLogger';
export { default as Form } from './dynamic/modules/Form';
export { default as Inspiration } from './dynamic/modules/Inspiration';
export { default as ItineraryList } from './dynamic/modules/ItineraryList';
export { default as ItineraryListItem } from './dynamic/modules/ItineraryListItem';
export { default as MakePayment } from './dynamic/modules/MakePayment';
export { default as PaymentError } from './dynamic/modules/PaymentError';
export { default as PaymentFail } from './dynamic/modules/PaymentFail';
export { default as PointedHeader } from './dynamic/modules/PointedHeader';
export { default as ProcessThreeDs } from './dynamic/modules/ProcessThreeDs';
export { default as ProgressIndicator } from './dynamic/modules/ProgressIndicator';
export { default as ReadMoreAccordion } from './dynamic/modules/ReadMoreAccordion';
export { default as SearchResultsInput } from './dynamic/modules/SearchResultsInput';
export { default as Tabs } from './dynamic/modules/Tabs';
export { default as TripAdvisor } from './dynamic/modules/TripAdvisor';


//----------------- React -----------------//
// Carousels
export { default as BlogCarousel } from './dynamic/react/Carousels/BlogCarousel';
export { default as DaysCarousel } from './dynamic/react/Carousels/DaysCarousel';
export { default as FoodCarousel } from './dynamic/react/Carousels/FoodCarousel';
export { default as HeroCarousel } from './dynamic/react/Carousels/HeroCarousel';
export { default as HistoryCarousel } from './dynamic/react/Carousels/HistoryCarousel';
export { default as LightboxCarousel } from './dynamic/react/Carousels/LightboxCarousel';
export { default as QuoteCarousel } from './dynamic/react/Carousels/QuoteCarousel';
export { default as SimpleCarousel } from './dynamic/react/Carousels/SimpleCarousel';
export { default as SmallCarousel } from './dynamic/react/Carousels/SmallCarousel';
export { default as TileCarousel } from './dynamic/react/Carousels/TileCarousel';

// Inspiration
export { default as InspirationCarousel } from './dynamic/react/Inspiration/InspirationCarousel';
export { default as InspirationResults } from './dynamic/react/Inspiration/InspirationResults';

// Itinerary
export { default as ItineraryTable } from './dynamic/react/Itinerary/ItineraryTable';

// Header
export { default as VideoHeader } from './dynamic/react/Header/Video';

// Navigation
export { default as SearchBar } from './dynamic/react/Navigation/SearchBar';
export { default as SearchBarTest1 } from './dynamic/react/Navigation/SearchBarTest1';
export { default as SearchBarTest2 } from './dynamic/react/Navigation/SearchBarTest2';
export { default as SiteSearch } from './dynamic/react/Navigation/SiteSearch';

// Booking Journey
export { default as BackToSearch } from './dynamic/react/BookingJourney/BackToSearch';
export { default as BoardSelection } from './dynamic/react/BookingJourney/BoardSelection';
export { default as CreateQuote } from './dynamic/react/BookingJourney/CreateQuote';
export { default as Excursions } from './dynamic/react/BookingJourney/Excursions';
export { default as ExtraInfo } from './dynamic/react/BookingJourney/ExtraInfo';
export { default as FlightExtras } from './dynamic/react/BookingJourney/FlightExtras';
export { default as Flights } from './dynamic/react/BookingJourney/Flights';
export { default as Rooms } from './dynamic/react/BookingJourney/Rooms';
export { default as MiniBasket } from './dynamic/react/BookingJourney/MiniBasket';
export { default as HotelSearch } from './dynamic/react/BookingJourney/HotelSearch';
export { default as PassengerDetails } from './dynamic/react/BookingJourney/PassengerDetails';
export { default as Transfers } from './dynamic/react/BookingJourney/Transfers';
export { default as QuoteSummary } from './dynamic/react/BookingJourney/QuoteSummary';

// Maps
export { default as ItineraryMap } from './dynamic/react/Maps/ItineraryMap';
export { default as MapCustom } from './dynamic/react/Maps/MapCustom';
export { default as MapPipe } from './dynamic/react/Maps/MapPipe';
export { default as MapSingle } from './dynamic/react/Maps/MapSingle';
